import { NgModule } from '@angular/core'
import { SideFrameComponent } from '@components/side-frame/side-frame.component'

@NgModule({
  declarations: [SideFrameComponent],
  exports: [SideFrameComponent],
  imports: [],
})
export class SideFrameModule {}
